import { combineReducers } from 'redux'
import { tableize } from 'inflected'
import Immutable from 'immutable'

import { EventTracker } from 'back_office/v2/utils/utils'

class ORM {
  static models = {}

  static __modelCache = {}

  static reducer (state = {}, action, globalState) {
    const reducers = {}

    // Group models by their stateKey and create reducers
    for (const name in this.models) {
      const model = this.models[name]
      const stateKey = model.options?.stateKey || tableize(name)

      if (reducers[stateKey]) {
        // Multiple models share this stateKey - combine reducers
        const existingReducer = reducers[stateKey]
        const newReducer = model.getReducer()

        reducers[stateKey] = (collection, action) => {
          return newReducer(existingReducer(collection, action), action)
        }
      } else {
        // First model for this stateKey
        reducers[stateKey] = model.getReducer()
      }
    }

    reducers.pendingRequests = (requests = Immutable.List(), action) => {
      let index, type

      EventTracker.trackDispatch(globalState, action)

      if (action.type.endsWith('_START')) {
        type = action.type.replace('_START', '')
        requests = requests.push(type)
      }

      if (action.type.endsWith('_ERROR')) {
        type = action.type.replace('_ERROR', '')
        index = requests.indexOf(type)
        requests = requests.delete(index)
      }

      if (action.type.endsWith('_SUCCESS')) {
        type = action.type.replace('_SUCCESS', '')
        index = requests.indexOf(type)
        requests = requests.delete(index)
      }

      return requests
    }

    return combineReducers(reducers)(state, action)
  }
}

// For debugging purposes, expose the ORM instance on the window.
// Uncomment the line below to enable this.
// window.ORM = ORM

export default ORM
